import { BuyFeatureRequestParams, GambleRequestParams, SpinResponse } from '@cgs/data-access';

export const GAME_ACTION_HANDLER_TOKEN = Symbol('GAME_ACTION_HANDLER_TOKEN');

export interface BuyFeatureParams extends BuyFeatureRequestParams {
  bet: number;
}

export interface GameActionHandler {
  doSpin(): void;
  doStop(): void;
  buyFeature(params: BuyFeatureParams): Promise<SpinResponse | null>;
  gamble(params: GambleRequestParams): Promise<SpinResponse>;
}
